import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import EmptyMap from '../../components/Map/emptyMap'
import Map from '../../components/Map'
import toolTipFormatter from './toolTipFormatter'
import MapLegend from './MapLegendHorizontalBirthTrend'
import styles from './RSVMap.module.scss'
import { useAuthState } from '../../components/AuthProvider'
import { displayDate } from './dates'
const BirthTrendMap = ({ zoomLocation }) => {
  const { user } = useAuthState()
  const chartRef = useRef(null)
  const location = useLocation()
  const hash = location.hash
  const [getMapStates, setMapStates] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getStateJson, setStateJson] = useState()
  const { mapOptions, regionSelected, setRegionSelected,setDisplayDate } = useGeoState()

  if (hash) {
    if (hash.split('-').length > 1) {
      setRegionSelected(hash.split('-')[0].replace('#', ''))
    }
  }
useEffect(() => {
    fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/getdashmap`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            requester: JSON.stringify(window.localStorage.getItem('requester')),
          },
          body: JSON.stringify({
            start_date:displayDate,
            end_date:displayDate,
            geo_type:'STATE',
            trimester_ids:'0',
            age_group_ids:'0',
            comorb_ids:'',
            category_ids:1
          }),
          withCredentials: true,
          credentials: 'include',
        }
      )
        .then((response) => response.json())
        .then((resData)=>{
          if (resData !== null && resData !== undefined) {
            if (resData.status === 200) 
            {
                if(Object.keys(resData.data.results).length === 0)
                {
                  setErrorCode(resData.status)
                  setErrorMessage(resData.message)
                  setErrorSubject(resData.subject)
                  seterrorOccured(true)
                }
                else{
                var datacount= Object.keys(resData.data.results).length-1 
                setDisplayDate(Object.keys(resData.data.results)[datacount]) 
                setMapStates(resData.data.results)
                }
            }
            else{
                setErrorCode(resData.status)
                setErrorMessage(resData.message)
                setErrorSubject(resData.subject)
                seterrorOccured(true)
            }
           
          }
        }).catch((err) => {
          seterrorOccured(true)
        })},[1])

  useEffect(() => {
    let url = `${window.location.origin}/birthtrend/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])

  if (errorOccured) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }

  return (
    <div className={`${styles.base}`}>
      {regionSelected === 'state' && (
        <>
          {getMapStates !== undefined && getStateJson ? (
            <>
              <Map
               toolTipFormatter={toolTipFormatter}
               activeCbsasData={null}
               statesData={getMapStates}
               cbsaData={null}
               mapOptions={mapOptions}
               mapType="countymap"
               mapDataType={0}
               stateJson={getStateJson}
               dashboardType="birthtrend"
                mapHeight="35vh"
                mapWidth="50vh"
                enableButtons={false}
                enableTooltip={false}
                chartRef={chartRef}
                enableMouseTracking={false}
              />
              <MapLegend className={styles.mapLegend} />
            </>
          ) : (
            <EmptyMap
              mapHeight="30vh"
              mapWidth="60vh"
              stateJson={getStateJson}
            />
          )}
        </>
      )}
    </div>
  )
}

export default BirthTrendMap
